import { render, staticRenderFns } from "./BlocAdd.vue?vue&type=template&id=c3fd0aea&"
import script from "./BlocAdd.vue?vue&type=script&lang=js&"
export * from "./BlocAdd.vue?vue&type=script&lang=js&"
import style0 from "./BlocAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports